module.exports = __webpack_public_path__ + "static/media/9.08fd21aa.svg";